import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  description: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    color: theme.colorPalette.green_80
  }
});

export default makeStyles(styles);
